import {mapGetters} from 'vuex'
import DoubleFace from "@/modules/index/views/systemSet/modelManage/components/doubleface";
export default {
  name: 'mw-table',

  data() {

    let me = this, data = {
      total: 0,
      dataList: [],
      filters: {},
      loading: false,
      colSort:'',
      colDir:'',
      multipleSelection:[],
      enableSortable: false
    };
    if (me.pagination) {
      return this.mwUtil.applyIf(
        data, this.mwConfig.pagination)
    } else {
      return data;
    }
  },
  created() {

  },

  props: {
    api: {  //数据 api
      type: String
    },
    autoLoad: {  //是否自动加载数据
      type: Boolean,
      default: true
    },

    data:{
      type:Array
    },
    currentKey:{
      type: String,
      default:'default'
    },
    pagination: {  //是否分页
      type: Boolean,
      default: true
    },
    noPaginationLimit:{  //不分页的记录数
      type: Number
    },
    readerAuthorize:{  //读作者域
      type: Boolean
    },
    border:{
      type: Boolean,
      default: true
    } ,
    showHeader:{  //是否显示表头
      type: Boolean,
      default: true
    },
    defaultParams: {  //默认参数
      type: Object
    },
    customCondition:{ //自定义条件
      type: String
    },
    /*expanderDataType:{ //行展开数据
      type: String
    },*/
    showRowExpander:Boolean,
    extCustomCondition:{ //扩展的自定义条件
      type: String
    },
    defaultParamsAutoLoad: {  //默认参数改变是否自动刷新列表
      type: Boolean,
      default: false
    },
    applicationId:{ //应用ID
      type: String
    },
    unitFilter:{  //单位过滤
      type: Boolean,
      default: false
    },
    deptFilter:{  //部门过滤
      type: Boolean,
      default: false
    },

    defaultSort: {  //默认排序
      type: Array,
      default: function () {
        return [];
      }
    },

    nowrap:{     //不自动换行
      type: Boolean,
      default: true
    },

    columns: {   //列配置
      type: Array,
      default: function () {
        return [];
      }
    },
    singleSelect:{  //是否单选
      type: Boolean,
      default: false
    },
    defaultDblClick:{  //是否不默认双击事件
      type: Boolean,
      default: true
    },
    allowLoaded:{
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.processPageSize();
      if (this.autoLoad) {
        this.loadData();
      }
    })
  },
  computed: {
    ...mapGetters([
      'curSelUnitId',
      'curSelDeptId'
    ])
  },
  watch: {
    defaultParams(val) {
      this.defaultParams=val;
      this.currentPage=1;
      this.filters={};
      if(this.defaultParamsAutoLoad){
        this.loadData();
      }else{
        this.defaultParamsChange();
      }
    },

    currentKey(currentKey) {
      this.currentKey = currentKey;
      this.currentPage=1;
      this.filters={};
      //因需要计算limit，需要加载完dom后才加载树
      this.$nextTick(()=>{
        this.loadData();
      })
    },
    dataList() {
      if(this.enableSortable)this.sortable();
    }
  },
  methods: {
    rowExpandChange(row,expandedRows){
      let copyRows=expandedRows.map(r=>r);
      let allRows=this.dataList;
      copyRows.sort((a,b)=>{
        let indexA=allRows.indexOf(a);
        let indexB=allRows.indexOf(b);
        return indexA<indexB?-1:indexA>indexB?1:0;
      });
      let index=copyRows.indexOf(row);
      if (index > -1) {
        this.$nextTick(()=>{
          let container=$(this.$el).find(".mw-row-expand-container").eq(index);
          this.$emit("rowExpanded", row,container);
        });
      }
    },
    _rowSelectable(row,index) {
       return  !_.isFunction(this.rowSelectable) || this.rowSelectable(row,index);
    },
    getRowKeys(row){
      return row.id
    },
    processPageSize(){
      let me = this;
      if (me.pagination) {
        if(me.defaultParams && me.defaultParams.limit){
          me.limit = me.defaultParams.limit;
        }else{
           if(!me.mwRef("multipleTable")) return;
           let tableHeight = $(me.mwRef("multipleTable").$el).height();
           let rowNum = Math.floor(tableHeight/38 );
           if(rowNum<6)rowNum = 6;
           me.limit = rowNum;
        }
      }
    },
    columnClick($scope,scope,func){
      let me=this;
      if($scope)
        func.call($scope,scope.row,me._getMe(),me.currentKey)
      else
        func(scope.row,me._getMe(),me.currentKey)
    },

    defaultParamsChange(){
      //this.processPageSize();
      this.$emit('params-change',this.defaultParams);
    },
    getMultipleSelection(){
      return this.multipleSelection;
    },

    selectByProp(prop,value){
      let idx=undefined;
      for(let i=0;i<this.dataList.length;i++){
          if(this.dataList[i][prop]===value){
            idx=i;
            break;
          }
      }
      if(idx !=undefined){
        if(this.singleSelect) {
          this.mwRef('multipleTable').clearSelection();
        }
        this.mwRef('multipleTable').setCurrentRow(this.dataList[idx]);
        this.mwRef('multipleTable').toggleRowSelection(this.dataList[idx]);
      }
    },
    selectAll(selection){
      this.$emit('selectAll',selection);
    },
    select(selection, row){
      if(this.singleSelect){
        this.mwRef('multipleTable').clearSelection();
        this.multipleSelection = [];   //单选bug，需要把已选的数据清掉
        this.mwRef('multipleTable').toggleRowSelection(row);
      }
      this.$emit('select',selection, row);
    },

    clearSelection(){
      this.mwRef('multipleTable').clearSelection();
    },

    rowClick(row, event, column){
      let index=this.dataList.indexOf(row);
      let selectable=this._rowSelectable(row,index);
      if(this.singleSelect && selectable){
        this.mwRef('multipleTable').clearSelection();
      }
      this.$emit('rowClick',row, event, column);
      if (selectable) {
        this.mwRef('multipleTable').toggleRowSelection(row);
      }
    } ,
    toggleRowSelection(row,selected){
      this.mwRef('multipleTable').toggleRowSelection(row,selected);
    },
    selectChange:function(selection){
      this.multipleSelection=selection;
      this.$emit('selectChange',selection);
    },
    rowStyle:function(row,index){
      let ret = {}
      this.$emit('rowStyle',row,index,ret);
      return ret;
    },
    refresh(){
      this.loadData();
    },
    search(filter){
      this.loadData(filter)
    },

    getData(){
      return this.dataList;
    },

    setData(data,callback){
      this.dataList=data;
      if(callback){
        this.$nextTick(()=>{
          callback();
        })
      }
    },
   /* clearFilter(filter){
      this.clearFilters = {};
    },*/
    loadData: function (filter) {
      if(!this.allowLoaded){
          return;
      }
      if(!this.api){
        this.dataList=this.data;
      }else {
        let me = this;
        let para = {};
        if (me.pagination) {
          para = {
            start: (me.currentPage - 1) * me.limit,
            limit: me.limit
          };
        } else {
          if (me.noPaginationLimit != undefined) {
            para = {
              start: 0,
              limit: me.noPaginationLimit
            };
          }
        }
        if (filter) {
          let keys = me.mwLodash.keys(filter);
          let fm = {};
          keys.forEach(v => {
            if (filter[v]) {
              fm[v] = filter[v];
            }
          })
          keys = me.mwLodash.keys(fm);
          if (keys.length > 0) {
            this.currentPage=1;
            if(para.start!=undefined){
              para.start=0;
            }
            me.filters = {filter: fm};
          }
          else{
            me.filters = {};
          }
        }
        me._applyNotEmptyIf(para,me.filters);
        if (me.defaultParams) {
          this.mwUtil.applyIf(para, me.defaultParams)
        }
        me.loading = true;
        if(me.colSort && me.colDir){
          para.sorts = [{sort:me.colSort,dir:me.colDir}];
        }else{
          para.sorts = me.defaultSort;
        }
        if(me.unitFilter){
          if(me.curSelUnitId){
            para.unitFilter=me.curSelUnitId
          }
        }
        if(me.deptFilter){
          if(me.curSelDeptId){
            para.deptFilter=me.curSelDeptId
          }
        }

        if(me.customCondition){
          para.customCondition=me.customCondition;
        }

        if(me.extCustomCondition){
          para.extCustomCondition=me.extCustomCondition;
        }

        if(me.readerAuthorize!=undefined){
          para.readerAuthorize=me.readerAuthorize;
        }
        if(me.applicationId){
          para.applicationId=me.applicationId;
        }
        me.$emit('beforeloadData',para);
        if(!me.api.startsWith("/")){
          if(me.api.startsWith("#")){//内部service
            eval("PF.invokeInner('" + me.api.substring(1) + "',para)").then((data) =>
            {this.dataList = data.result;
              if(me.pagination){
                if(data.totalCount)
                  this.total =Number(data.totalCount)
                else
                  this.total =0
              }
              me._dataLoad();
              this.loading = false;
            });
          }else{
            eval('this.mwApi.' + me.api + '(para)').then((data) =>
            {this.dataList = data.result;
              if(me.pagination){
                if(data.totalCount)
                  this.total =Number(data.totalCount)
                else
                  this.total =0
              }
              me._dataLoad();
              this.loading = false;me._rendered();});
          }
        }else{
          //公用service
          eval("PF.invoke('" + me.api.substring(1) + "',para)").then((data) =>
          {this.dataList = data.result;
            if(me.pagination){
              if(data.totalCount)
                this.total =Number(data.totalCount)
              else
                this.total =0
            }
            me._dataLoad();
            this.loading = false;me._rendered();});
        }
      }
    },
    _dataLoad(){
      this.$emit('dataLoaded',this.dataList,this.total);
    },
    _rendered(){
      let me=this;
      this.$nextTick(()=>{
        this.$emit('rendered',this.dataList,me.$el);
      })
    },
    _applyNotEmptyIf: function (o, c) {
      if (o) {
        for (var p in c) {
          if (!this.mwUtil.isDefined(o[p])) {
            if (c[p]) {
              o[p] = c[p];
            }
          }
        }
      }
      return o;
    },
    rowDblClick: function (row, event) {
      let me=this;
      if(me.defaultDblClick){

      }else {
        me.$emit('row-dblclick', row, event);
      }
    },
    sizeChange(val) {
      this.limit = val;
      this.loadData();
    },
    currentChange(val) {
      this.currentPage = val;
      this.loadData();
      this.mwRef('multipleTable').bodyWrapper.scrollTop=0   //刷新页面后滚动条显示table最上方
    },
    sortChange:function(column, prop, order){
      if(column){
        if(column.prop && column.order){
          this.colDir = (column.order == "descending" ? "DESC" : "ASC");
          this.colSort = column.prop;
          this.loadData();
          return;
        }
      }
      this.colDir = '';
      this.colSort = '';
      this.loadData();
    },
    _getScope(){
      return this;
    },
    _getMe() {
      let me = this;
      return {
        mwMsg: me.mwMsg.bind(me),
        mwConfirm: me.mwConfirm.bind(me),
        mwApi: me.mwApi,
        mwUtil: me.mwUtil,
        mwConfig: me.mwConfig,
        refresh: me.refresh
      };
    },
    getSortableEl() {
      return $(this.$el).find(".el-table__body-wrapper tbody");
    },
    sortable() {
      let me=this;
      me.enableSortable=true; //直接调用方法的时候。设置标识。
      let el=this.getSortableEl();
      let dragStart=-1;
      let dragEnd=-1;
      el.sortable({
        start:function(event,ui){
          let item=ui.item;
          dragStart=item.index();
        },
        update:function(event,ui){
          let item=ui.item;
          dragEnd=item.index();
          updateDataList(dragStart, dragEnd);
        }
      }).disableSelection();
      function updateDataList(fromIndex,toIndex){
        let copyDataList=me.dataList.slice();
        let d = copyDataList.splice(fromIndex, 1)[0];
        copyDataList.splice(toIndex, 0, d);
        let changes=[];
        for (let i = 0; i < me.dataList.length; i++) {
          let row=me.dataList[i];
          if (me.dataList[i] !== copyDataList[i]) {
            changes.push({
              row:row,
              oldIndex:i,
              newIndex:copyDataList.indexOf(row)
            });
          }
        }
        me.dataList=copyDataList;
        me.$emit("sortableUpdate",changes);
      }
    },
    cancelSortable() {
      this.enableSortable=false;
      let el=this.getSortableEl();
      el.sortable("cancel");
    }
  },
  components: {
    DoubleFace
  }
  /*render() {
    let key;
    let cols=this.columns.map((item,index)=>{
      key=this.currentKey+index;
      if(item.slot){
        return  (<el-table-column
          prop={item.prop}
          label={item.label}
          key={key}
          type={item.type}
          width={item.width?(item.autoWidth?undefined:item.width):undefined}
          formatter={item.formatter}
          show-overflow-tooltip={true}
          resizable={true}
          scopedSlots={{default:(scope)=>{
            let icon;
            let type=item.slot.type;
            if(type=='button'){
              return item.slot.items.map(it=> {
                if(it.icon){
                  icon=<i class={it.icon}></i>;
                }
                return <el-button size='mini' class={'mw-btn-mini'} onClick={(e)=>{e.stopPropagation();it.func(scope.row,this._getMe(),scope.$index)}}>{icon}{it.label}</el-button>
              })
            }else if(type=='href') {
              return <a onClick={()=>item.slot.func(scope.row,scope.$index)}>{item.slot.label?item.slot.label:scope.row[item.prop]}</a>
            }
            return null;
          }
          }}>
        </el-table-column>)
      }else{
        return  (<el-table-column
          prop={item.prop}
          label={item.label?item.label:('index'==item.type?'序号':undefined)}
          key={key}
          type={item.type}
          resizable={true}
          show-overflow-tooltip={('selection'==item.type || ('index'==item.type))?false:true}
          formatter={item.formatter}
          width={(item.width?(item.autoWidth?undefined:item.width):('selection'==item.type)?'35':('index'==item.type)?45:undefined)}
        >
        </el-table-column>)
      }
    });
    return (
      <div class="mw-panel">
        <div  class={{ 'mw-pagination__body': this.pagination,'mw-no-pagination__body': !this.pagination, 'mw-panel': !this.pagination}}>
          <el-table  height="0" ref='multipleTable' class={{ 'mw-table': true, 'mw-single-select': this.singleSelect}}  border={this.border} data={this.dataList}
                    show-header={this.showHeader}        v-loading={this.loading} onSort-change={this.sortChange}
      onSelect={this.select}              /!*tooltip-effect='light'*!/        onRow-click ={this.rowClick}    onSelection-change={this.selectChange}     onRow-dblclick={this.rowDblClick} highlight-current-row>
            {cols}
          </el-table>
        </div>
        {(this.pagination?<mw-pagination onSize-change={this.sizeChange} onCurrent-change={this.currentChange}
                                         total={this.total}></mw-pagination>:null)}

      </div>
    )
  }*/
}



// WEBPACK FOOTER //
// ./src/common/components/extend/table/table.js